export default function initCoverCarouselCounter() {
    var $ = window.jQuery;

    if (!$) {
        return;
    }

    var $carousel = $('.cover_carousel');
    var $status = $('.cover_arrows_cnt');

    if (!$carousel.length || !$status.length) {
        return;
    }

    function updateCounter(slick, currentSlide) {
        var current = (currentSlide != null ? currentSlide : slick.currentSlide || 0) + 1;
        var total = slick.slideCount;

        if (!total) {
            total = $carousel.find('.slick-slide:not(.slick-cloned)').length;
        }

        if (!total) {
            total = $carousel.children().length;
        }

        $status.text(current + '/' + total);
    }

    $carousel.on('init reInit afterChange', function (event, slick, currentSlide) {
        updateCounter(slick, currentSlide);
    });

    if ($carousel.hasClass('slick-initialized')) {
        var slick = $carousel.slick('getSlick');
        updateCounter(slick, slick.currentSlide);
    }
}



// WEBPACK FOOTER //
// ./_src/js/cover-carousel-counter.js